var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnknown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#444546"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.486 6.486 2 12 2C17.514 2 22 6.486 22 12C22 17.514 17.514 22 12 22C6.486 22 2 17.514 2 12ZM13.1596 18V15.6H10.7596V18H13.1596ZM11.9596 6C9.92201 6 8.22326 7.45103 7.84039 9.37615L10.1942 9.84692C10.3583 9.02188 11.0864 8.4 11.9596 8.4C12.9537 8.4 13.7596 9.20588 13.7596 10.2C13.7596 11.1941 12.9537 12 11.9596 12H10.7596V14.4H11.9596C14.2792 14.4 16.1596 12.5196 16.1596 10.2C16.1596 7.8804 14.2792 6 11.9596 6Z",
    fill: "#6F7073"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknown);
export default __webpack_public_path__ + "static/media/UNKNOWN.29bfe86a87ba54209eccd2a801f29feb.svg";
export { ForwardRef as ReactComponent };